import { render, staticRenderFns } from "./XLabelDesigner.vue?vue&type=template&id=0e8751fb&scoped=true"
import script from "./XLabelDesigner.vue?vue&type=script&lang=js"
export * from "./XLabelDesigner.vue?vue&type=script&lang=js"
import style0 from "./XLabelDesigner.vue?vue&type=style&index=0&id=0e8751fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8751fb",
  null
  
)

export default component.exports